import React, { useCallback, useEffect, useState } from "react";
import InstructorTable from "../../components/Tables/InstructorTable";
import useInstructorCrud from "../../hooks/CRUD/useInstructorCrud";
import { API } from "../../shared/api/Api";
import instructorFields from "../../config/instructorFields";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectUserInformations } from "../../features/authSlice";
import { showToast } from "../../utils/utils";

const DEBOUNCE_DELAY = 700;

const InstructorPage = () => {
  const [instructors, setInstructors] = useState([]);
  const [reFetchData, setReFetchData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [orderBy, setOrderBy] = useState("created_at"); // Default sorting column
  const [orderDir, setOrderDir] = useState("DESC"); // Default sorting direction
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const user = useSelector(selectUserInformations);

  const fetchInstructors = useCallback(async () => {
    setLoader(true);
    try {
      const { data } = await axios.get(
        `${API.Instructors.app_instructors_all}`,
        {
          params: {
            limit: 3,
            page: currentPage,
            search: debouncedSearch,
            orderBy: orderBy,
            orderDir: orderDir,
          },
          headers: { Authorization: `Bearer ${user.token}`, lang: "en" },
        }
      );

      if (data.status === 200 && data.errorCode === 0) {
        setInstructors(data.data.items);
        setCurrentPage(data.data.current_page);
        setTotalPages(data.data.last_page);
      } else {
        showToast("Error", "Failed to fetch courses", "error");
      }
    } catch (error) {
      showToast(
        "Error",
        error.response?.data?.message || "An error occurred",
        "error"
      );
    } finally {
      setLoader(false);
      setReFetchData(false);
    }
  }, [currentPage, user.token, debouncedSearch, orderBy, orderDir]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1); // Reset to the first page on search change
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    try {
      setInstructors([]);
      fetchInstructors();
    } catch (error) {
      console.log(error);
    }
  }, [currentPage, fetchInstructors, reFetchData, setReFetchData]);

  const handleSort = (column, direction) => {
    setOrderBy(column);
    setOrderDir(direction);
  };


  return (
    <div className="min-h-screen p-2 sl:pt-0 sm:p-2 md:p-4 sl:p-6">
      <InstructorTable
        currentPage={currentPage}
        instructors={instructors}
        loader={loader}
        onPageChange={setCurrentPage}
        onSearchChange={setSearch}
        setReFetchData={setReFetchData}
        totalPages={totalPages}
        onSort={handleSort}
        currentOrderBy={orderBy}
        currentOrderDir={orderDir}
      />
    </div>
  );
};

export default InstructorPage;
